import type { GridProps } from '../../Grid';
import type { ComparisonColumn, ComparisonEmptySlot } from '../types';

export const resolveGridColumns = (count: number): GridProps['columns'] =>
  count as GridProps['columns'];

export const isEmptyColumn = (
  column: ComparisonColumn,
): column is ComparisonEmptySlot =>
  (column as ComparisonEmptySlot).kind === 'empty';

// Mobile grid configuration constants
const MOBILE_GRID_CONFIGS: Record<
  number,
  { columns: GridProps['columns']; gap: 'md'; className: string }
> = {
  1: { columns: 1, gap: 'md', className: 'w-full grid-cols-1' },
  2: { columns: 2, gap: 'md', className: 'w-full grid-cols-2' },
};

export const getMobileGridProps = (itemCount: number) => {
  if (itemCount <= 0) {
    return {
      columns: 1 as GridProps['columns'],
      gap: 'md' as const,
      className: 'w-full',
    };
  }
  return (
    MOBILE_GRID_CONFIGS[itemCount] || {
      columns: resolveGridColumns(itemCount),
      gap: 'md' as const,
      className: 'w-full',
    }
  );
};
